module.exports = __webpack_public_path__ + "img/order.b6b237f8.png";